<div class="top-bar d-flex align-items-center justify-content-between border-bottom pt-2 pb-2 mb-2">
    <div class="flex-grow-1">
        
        <h2 class="mb-1"><i class={{Icon}} *ngIf="Icon.length > 0"></i>{{Heading}} <span  *ngIf="details.length > 0">- {{details}}</span></h2>
        <p class="text-muted mb-0">{{Description}}</p>
    </div>
    <div class="ms-auto d-flex gap-2">
        <ng-content></ng-content>
    </div>
</div>
